import { render } from "./AppManageApi.vue?vue&type=template&id=3df43637"
import script from "./AppManageApi.vue?vue&type=script&setup=true&lang=js"
export * from "./AppManageApi.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/AppManage/AppManageApi.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3df43637"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3df43637', __exports__)) {
    api.reload('3df43637', __exports__)
  }
  
  module.hot.accept("./AppManageApi.vue?vue&type=template&id=3df43637", () => {
    api.rerender('3df43637', render)
  })

}


export default __exports__